// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"05e9cd14","453":"c8e9332e","455":"ca940224","977":"c8b86a12"}[chunkId] + ".chunk.js";
};